import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: '', key: 'imageUrl' },
      { label: 'SKU', key: 'skuNo' },
      { label: t('name'), key: 'name' },
      { label: t('InventoryLocations.binNo'), key: 'locationNumber' },
      { label: t('InventoryLocations.locationName'), key: 'locationName' },
      { label: t('count'), key: 'quantity' },
      {
        label: t('InventoryLocations.maxShelfCapacity'),
        key: 'maxShelfCapacity',
      },
      { label: t('minQuantity'), key: 'minQuantity' },
    ],
    [t],
  );
};
